import React from 'react';

const Timeline = () => <span>Timeline</span>;

export default Timeline;
